var React = require('react');

function Danger (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","vectorEffect":"non-scaling-stroke","d":"M39 20C39 9.506 30.494 1 20 1S1 9.506 1 20s8.506 19 19 19 19-8.506 19-19Zm-21.85-9.5a2.85 2.85 0 1 1 5.7 0v11.4a2.85 2.85 0 0 1-5.7 0V10.5ZM20 26.65a2.85 2.85 0 1 0 0 5.7 2.85 2.85 0 0 0 0-5.7Z","fillRule":"evenodd"}));
}

Danger.defaultProps = {"xmlSpace":"preserve","viewBox":"0 0 40 40"};

module.exports = Danger;

Danger.default = Danger;
